module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"claim.cost":"ค่าใช้จ่ายเรียกเก็บ","claim.cost.description":"ประเมินค่าใช้จ่ายที่ทางศูนย์จะเรียกเก็บ"}}')
  delete Component.options._Ctor
}
